@import "@/styles/variables";

.main_title {
	font-size: 17px;
	font-weight: 500;
	padding-top: 4px;
	padding-left: 22px;
	padding-right: 22px;
}

.maintainers {
	display: flex;
	flex-wrap: wrap;
	padding: 10px 1em;

	@media (max-width: 500px) {
		padding-left: 5px;
		padding-right: 5px;
	}

	.item {
		width: 25%;
		display: flex;
		justify-content: center;
		margin-bottom: 10px;

		@media (max-width: 900px) {
			width: 50%;
		}

		@media (max-width: 500px) {
			width: 100%;
		}

		.target {
			background-color: white;
			width: 98%;
			padding: 10px;
			border-radius: 5px;
			cursor: pointer;
			box-shadow: 10px 10px 15px #dfe1e6;

			.title {
				min-height: 3em;
				color: $primary-color;
			}

			.subtitle {
				text-align: right;
			}

			.hr {
				margin-top: 3px;
				margin-bottom: 3px;
			}
		}
	}
}

.main_row {
	margin-right: 20px !important;
	margin-left: 20px !important;
	margin-top: 5px;
	padding-bottom: 1em;

	.div_custom_action {
		width: 100%;
		display: flex;
		align-items: center;
		margin-bottom: 5px;
		justify-content: space-between;
	}

	@media (max-width: 750px) {
		margin-right: 10px !important;
		margin-left: 10px !important;
	}

	.filter {
		border-top-left-radius: 10px;
		border-bottom-left-radius: 10px;
		background-color: #ffffff;
		box-shadow: 5px 5px 10px #dfe1e6;
		border-right: 1px solid #d8d8d8;
		padding-right: 5px;
		padding-left: 5px;
		min-height: 82vh;
		max-height: 82vh;

		.filterTitle {
			margin-top: 15px;
			font-size: 15px;
		}

		.divContent {
			height: 83%;
			overflow-y: auto;
			overflow-x: hidden;
			padding: 0px 5px;

			&::-webkit-scrollbar {
				width: 5px;
				height: 5px;
			}

			&::-webkit-scrollbar-track {
				background: $gray-100;
			}

			&::-webkit-scrollbar-thumb {
				background-color: #a8a8a8;
				border-radius: 15px;
			}

			.divForm {
				margin-top: 10px;

				.divLabel {
					margin-bottom: 4px;
					display: flex;
					align-items: center;

					.label {
						font-weight: 500;
						font-size: 14px;
					}
				}
			}
		}

		.divFooter {
			display: flex;
			justify-content: space-evenly;
			padding-top: 7px;

			.buttonClean {
				padding: 2px 15px;
				font-size: 13px;
				font-weight: 500;

				background-color: white !important;
				color: #81ba43 !important;

				&:hover {
					background-color: #5d9125 !important;
					color: white !important;
				}
			}

			.buttonApply {
				padding: 2px 15px;
				font-size: 13px;
				font-weight: 500;
			}
		}
	}

	.main_col {
		min-height: 82vh;
		max-height: 82vh;
		display: flex;
		flex-direction: column;

		width: 100%;
		box-shadow: 5px 5px 10px #dfe1e6;
		background-color: white;

		border-top-right-radius: 10px;
		border-bottom-right-radius: 10px;

		@media (max-width: 750px) {
			min-height: 78vh;
			max-height: 78vh;
		}

		.header {
			height: 8%;
			flex-wrap: wrap;
			align-items: center;
			border-bottom: 0.5px solid #dee2e6;

			@media (max-width: 750px) {
				height: 10%;
				display: none;
			}

			&.have_action {
				@media (max-width: 750px) {
					display: flex;
				}
			}

			.col_base_action {
				display: flex;
				padding-right: 0px;

				.text {
					font-size: 10px;
				}

				.hr_vertical {
					border-left: 1px solid #81ba43;
					padding-left: 5px;

					@media (max-width: 750px) {
						display: none;
					}
				}

				.action {
					display: inline-flex;
					background-color: $gray-100;
					padding: 7px 10px;
					border-radius: 10px;
					font-size: 15px;
					font-weight: 500;
					margin-right: 10px;
					cursor: pointer;
					background-position: left;
					background-repeat: no-repeat;
					background-size: 40px 15px;

					&:hover {
						background-color: $primary-color;
						color: white;
					}
				}
			}

			.col_action {
				padding-left: 0px;

				@media (max-width: 750px) {
					padding-left: 5px;
				}

				.action {
					display: inline-flex;
					border: 1px solid #6c757d;
					padding: 7px 10px;
					border-radius: 5px;
					font-size: 13px;
					font-weight: 500;
					margin-right: 10px;
					cursor: pointer;
					background-position: left;
					background-repeat: no-repeat;
					background-size: 40px 15px;

					&:hover {
						background-color: $primary-color;
						color: white;
						border: none;
					}
				}
			}

			.optionButtonNew {
				display: flex;
				align-items: center;
				grid-gap: 0.35rem;
				gap: 0.35rem;
				padding: 0.4rem 0.75rem;
				border-radius: 0.5rem;
				cursor: pointer;
				color: $gray-700;
				font-weight: 500;
				border: 1px solid $gray-200;
				background-color: $gray-50;
				transition: all 0.2s ease;
				font-size: 15px;
			}

			.optionButton {
				display: flex;
				align-items: center;
				background-color: #fafafa;
				border-radius: 10px;
				font-size: 15px;
				font-weight: 500;
				cursor: pointer;
				padding: 7px 10px;

				height: 100%;
				justify-content: center;

				@media (max-width: 750px) {
					margin-bottom: 5px;
					padding: 5px;
					border-radius: 5px;
				}

				span {
					margin-left: 27px;
				}

				&:hover {
					background-color: $primary-color;
					color: white;
				}

				.icon {
					margin-right: 7px;
					margin-top: 3px;
				}

				&.exportInventory {
					position: relative;

					&::before {
						content: "";
						position: absolute;
						left: 0;
						top: 50%;
						transform: translateY(-50%);
						background-image: url("../../assets/images/desktop/descargarnegro.svg");
						background-repeat: no-repeat;
						background-size: 40px 20px;
						width: 40px;
						height: 20px;
					}

					&:hover::before {
						background-image: url("../../assets/images/desktop/descargarblanco.svg");
					}

					&.active::before {
						background-image: url("../../assets/images/desktop/descargarblanco.svg");
					}

					&.active {
						color: white;
						background-color: $primary-color;
					}

					&.up::before {
						transform: translateY(-50%) rotate(180deg);
					}
				}
			}
		}

		.table {
			height: 92%;
			overflow-y: auto;

			&::-webkit-scrollbar {
				width: 5px;
				height: 5px;
			}

			&::-webkit-scrollbar-track {
				background: $gray-100;
			}

			&::-webkit-scrollbar-thumb {
				background-color: #a8a8a8;
				border-radius: 15px;
			}

			.table_div {
				width: 100%;

				&.long_text {
					font-size: 13px;
				}

				&.multiple {
					flex-direction: column;
					font-size: 12px;
					min-height: 64px;

					.show_more {
						font-weight: bold;
						color: $primary-color;
						cursor: pointer;
						font-style: italic;
					}
				}

				&.editable {
					cursor: pointer;
				}

				.table_desktop {
					display: table;

					.table_head {
						position: sticky;
						top: 0;
						background-color: #ffffff;
					}

					@media (max-width: 750px) {
						// display: none;
					}

					.headerCellGroup {
						font-size: 10px;
					}

					.groupRow {
						font-size: 10px;
					}

					.table_tr {
						&.otherActive {
							color: #bbbbbb;
						}

						.table_td {
							padding-top: 5px;
							padding-bottom: 5px;
							padding-left: 5px;
							padding-right: 5px;
							border-top: 0px;
							border-bottom: 0.5px solid #ddd;

							&.first_td {
								padding-left: 5px;
								padding-right: 0px;
							}

							.subTableGroup {
								font-size: 12px;

								.headerCellGroup {
									align-content: center;
									text-align: center;
									border-top: 0px;
									font-size: 12px;
								}

								.subRowGroup {
									font-size: 10px;
								}
							}

							.table_div {
								height: 100%;
								// background-color: #fafafa;
								min-height: 3em;
								padding-top: 5px;
								padding-bottom: 5px;
								display: flex;
								align-items: center;
								flex-wrap: wrap;

								.icon {
									cursor: pointer;
									margin-left: 5px;
									margin-right: 5px;
									width: 1.5em;
									height: 1.5em;
								}

								&.active {
									background-color: #c7e0a9;
								}

								&.center {
									text-align: center;
									justify-content: center;
								}

								&.column {
									flex-direction: column;
								}

								&.right {
									text-align: right;
									justify-content: flex-end;
								}

								&.small_text {
									font-size: 13px;
								}

								&.first_text {
									padding-left: 10px;
								}

								&.first_div {
									color: $primary-color;
									border-top-left-radius: 5px;
									border-bottom-left-radius: 5px;
									justify-content: center;
								}

								&.last_div {
									border-top-right-radius: 5px;
									border-bottom-right-radius: 5px;
									justify-content: center;
								}
							}
						}
					}
				}

				.add_button {
					display: flex;
					justify-content: center;
					align-items: center;
					background-color: #81ba43;
					color: white;
					padding: 0.3rem 0.5rem;
					margin: 0.2rem 2px;
					border-radius: 5px;
					cursor: pointer;

					&:hover {
						background-color: $primary-hover;
					}
				}

				.editable_button {
					display: flex;

					.button_confirm {
						width: 50%;
						border: none;
						background-color: #81ba43;
						color: white;
						padding: 0.3rem 0.5rem;
						margin: 0.2rem 2px;
						border-radius: 5px;
						cursor: pointer;

						&:hover {
							background-color: $primary-hover;
						}
					}

					.button_cancel {
						width: 50%;
						border: none;
						background-color: #dc3545;
						color: white;
						padding: 0.3rem 0.5rem;
						margin: 0.2rem 2px;
						border-radius: 5px;
						cursor: pointer;

						&:hover {
							background-color: #a71d2a;
						}
					}
				}
			}
		}
	}
}

.main_form {
	.row_form {
		.subtitle {
			color: #8bc34a;
			font-style: italic;
		}

		.group_tools {
			display: flex;
			flex-wrap: wrap;
			font-size: 13px;

			.tool {
				width: 50%;

				.item {
					width: 98%;
					background-color: #dee2e6;
					padding: 5px;
					border: 1px solid gray;
					border-radius: 5px;
					margin-bottom: 3px;
					cursor: pointer;

					&.active {
						background-color: #f6ffec;
						border: 1px solid $primary-color;
					}
				}
			}
		}

		.group_options {
			display: flex;
			margin-bottom: 10px;

			.item {
				width: 50%;
				display: flex;
				justify-content: center;

				.div_icon {
					border: 1px solid $primary-color;
					color: $primary-color;
					display: flex;
					justify-content: center;
					align-items: center;
					width: 90%;
					cursor: pointer;
					border-radius: 5px;
					min-height: 4em;

					&.machinery {
						background-image: url("../../assets/images/icons/Settings/machineries.svg");
						background-position: right;
						background-repeat: no-repeat;
						background-size: 20em 2.5em;

						&:hover {
							background-image: url("../../assets/images/icons/Settings/white/maquinarias.svg");
						}

						&.active {
							background-image: url("../../assets/images/icons/Settings/white/maquinarias.svg");
						}

						@media (max-width: 750px) {
							background-size: 10em 2.5em;
						}
					}

					&.especie {
						background-image: url("../../assets/images/icons/Settings/especie.svg");
						background-position: right;
						background-repeat: no-repeat;
						background-size: 20em 2.5em;

						&:hover {
							background-image: url("../../assets/images/icons/Settings/white/especies.svg");
						}

						&.active {
							background-image: url("../../assets/images/icons/Settings/white/especies.svg");
						}

						@media (max-width: 750px) {
							background-size: 10em 2.5em;
						}
					}

					&.active {
						background-color: $primary-color;
						color: white;
					}

					&:hover {
						background-color: $primary-color;
						color: white;
					}

					.text_icon {
						margin-left: 45px;

						@media (max-width: 750px) {
							display: none;
						}
					}
				}
			}
		}

		&.list {
			display: flex;
			margin-top: 10px;
			justify-content: right;
		}

		.button {
			display: flex;
			align-items: center;
			font-size: 14px;
			font-weight: 500;
			max-width: 100%;
			margin-left: 15px;
			background-color: #81ba43;
			color: white;
			padding: 0.3rem 0.5rem;
			margin: 0.2rem 1rem;
			border-radius: 5px;

			.icon {
				fill: #424242;
				width: 1rem;
				height: 1rem;
				margin-right: 0.5rem;
			}

			&:hover {
				cursor: pointer;
				background-color: $primary-hover;
				color: white;
			}
		}

		.table {
			width: 100%;

			.thead {
				background-color: #555555;
				color: white;
				text-align: center;
				font-size: 13px;
			}
		}

		.group_form {
			margin-bottom: 5px;

			.label {
				font-size: 13px;
				margin-bottom: 2px;
				font-weight: 500;
			}
		}

		.label {
			margin-bottom: 2px;
		}

		.web_div_detail {
			margin-left: 5px;
			margin-right: 5px;
			padding: 6px;
			border-radius: 10px;
			background-color: #7fb02f2b;
			border: 1px solid #a5a5a5;
			margin-bottom: 10px;
		}
	}

	.modal_title {
		color: #81ba43;
		font-size: 15px;
		margin-bottom: 0px;
		margin-top: 0px;
	}

	.modal_tabs {
		font-size: 13px;
		width: 100%;
	}

	.list {
		@media (max-width: 750px) {
			padding-left: 3px;
			padding-right: 3px;
		}

		.section_title {
			font-size: 13px;
			padding-top: 4px;
			font-weight: 500;
		}

		.section_container {
			width: 100%;
			margin: 0;
			list-style: none;
			padding: 5px;
			border-radius: 5px;
			font-size: 15px;

			display: inline-flex;
			flex-direction: column;
			padding-top: 15px;
			padding-bottom: 15px;
			margin-bottom: 4px;

			min-height: 50vh;
			max-height: 50vh;
			overflow-y: auto;
			background-color: #7fb02f2e;

			&::-webkit-scrollbar {
				width: 5px;
				height: 5px;
			}

			&::-webkit-scrollbar-track {
				background: $gray-100;
			}

			&::-webkit-scrollbar-thumb {
				background-color: #a8a8a8;
				border-radius: 15px;
			}
		}

		.section_item {
			padding: 7px 10px;
			color: #212529;
			border-radius: 5px;
			background-color: whitesmoke;
			margin: 3px 0px;
			border: 1px solid $primary-color;

			&:focus {
				outline: none;
				border: 2px solid $secondary-color;
			}

			.section_item_div {
				display: flex;
				justify-content: space-between;
				align-items: center;
			}
		}
	}
}

.tabs_users {
	.table_tabs {
		margin-top: 10px;
		width: 100%;

		.div_title_permission {
			background-color: #b6d189;
			padding-left: 1em;
			font-size: 13px;
		}

		.div_title {
			min-height: 2em;
			background-color: $primary-color;
			display: flex;
			justify-content: center;
			align-items: center;
			color: white;

			&.first {
				border-top-left-radius: 10px;
			}

			&.last {
				justify-content: left;
				border-top-right-radius: 10px;
			}
		}
	}
}

.bc_modal {
	.bc_modal_div {
		display: flex;
		align-items: center;
		justify-content: center;
		border: 1px solid $primary-color;
		border-radius: 5px;
		margin-bottom: 1em;
		padding: 1em;
		cursor: pointer;

		&.especie {
			background-image: url("../../assets/images/icons/Settings/especie.svg");
			background-position: left;
			background-repeat: no-repeat;
			background-size: 20em 2.5em;

			@media (max-width: 750px) {
				background-size: 10em 2.5em;
			}
		}

		&.variedad {
			background-image: url("../../assets/images/icons/Settings/variedad.svg");
			background-position: left;
			background-repeat: no-repeat;
			background-size: 20em 2.5em;

			@media (max-width: 750px) {
				background-size: 10em 2.5em;
			}
		}

		&.cuartel {
			background-image: url("../../assets/images/icons/Settings/cuartel.svg");
			background-position: left;
			background-repeat: no-repeat;
			background-size: 20em 2.5em;

			@media (max-width: 750px) {
				background-size: 10em 2.5em;
			}
		}

		&:hover {
			background-color: $primary-color;
			color: white;
		}
	}
}

.maintainers_web {
	display: flex;
	flex-wrap: wrap;

	.page {
		width: 50%;
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 5px;

		@media (max-width: 750px) {
			width: 100%;
		}

		.page_content {
			width: 97%;
			background-color: white;
			min-height: 11em;
			border-radius: 5px;
			cursor: pointer;
			box-shadow: 10px 10px 15px #dfe1e6;

			.resume {
				.title {
					font-size: 20px;
					color: $primary-color;
					font-weight: 500;
					padding: 5px 15px 0px 15px;
				}

				.subtitle {
					padding-left: 15px;
					color: $secondary-color;
					font-weight: 500;
				}

				.content {
					padding-left: 5px;
					color: black;
					font-size: 13px;
				}
			}
		}
	}
}

.span_danger {
	cursor: pointer;
	background-color: #dc3545;
	color: white;
}

.icon_flags {
	width: 1.5em;
	height: 1.5em;
}

.icon_number {
	background-color: #81ba43;
	padding: 2px 10px;
	border-radius: 5px;
	cursor: pointer;
	color: white;
}

.input_price input {
	text-align: right;
}

.price,
.price_manual,
.price_combined {
	cursor: pointer;
	font-weight: bold;
	color: $primary-color;
}

.price_manual {
	color: $danger-color;
}

.price_combined {
	color: #ff9a24;
}

.option_category {
	background-color: #e3e3e3;
	border: 1px solid #8f8f8f;
	padding: 8px 10px;
	border-radius: 5px;
	margin-top: 5px;
	cursor: pointer;

	&.active {
		background-color: #81ba434d;
		border: 1px solid $primary-color;
	}
}

.table_tr_expanded {
	background-color: #c7e0a9;
}

.th_detail {
	font-size: 10px;
	font-weight: 400;
	text-align: center;
	margin: auto;
	padding-right: 0px !important;
	padding-left: 0px !important;
	border: 0px !important;
}

.upload_products {
	.loading {
		text-align: center;
		margin-top: 1em;

		p {
			margin-top: 0.5em;
			font-size: 14px;
			color: $gray-400;
		}
	}

	.modal {
		text-align: center;
		padding: 2em 0;
	}

	.upload_cards {
		display: flex;
		gap: 2em;
		justify-content: center;
		margin-bottom: 1em;
	}

	.upload_card_wrapper {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 0.5em;
	}

	.modal_card {
		border: 1px solid $gray-200;
		border-radius: 8px;
		width: 200px;
		cursor: pointer;
		display: flex;
		flex-direction: column;
		justify-content: flex-end;
		min-height: 200px;
		transition: all 0.2s ease;
		cursor: pointer;

		&:hover {
			transform: translateY(-2px);
			box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
		}

		.modal_card_icon {
			font-size: 3em;
			color: $primary-color;
			margin-bottom: 2rem;
			margin-top: 2rem;
		}

		.modal_card_title {
			color: black;
			margin: 0;
			font-size: 16px;

			width: 100%;
			border-top: 2px solid $primary-color;
			padding: 1rem 0.5rem;
		}

		.modal_card_button {
			border-width: 2px;
			background: white !important;
			color: $primary-color !important;
			margin-right: 5px;
			line-height: 1.2;
		}
	}

	.modal_card_download {
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 6px;
		width: 200px;
		border: none;
		background: transparent;
		color: $primary-color;
		font-size: 13px;
		padding: 0.4rem 0.5rem;
		cursor: pointer;
		text-decoration: none;

		&:hover {
			text-decoration: underline;
		}
	}

	.modal_child {
		padding-top: 0px;

		.bulk_preview_header {
			display: flex;
			justify-content: space-between;
			align-items: baseline;
			gap: 1rem;
			margin-bottom: 0.8rem;

			.bulk_preview_subtitle {
				margin: 0;
				font-size: 13px;
				color: $gray-500;
			}
		}

		.bulk_preview_table_wrap {
			border: 1px solid $gray-200;
			border-radius: 12px;
			overflow: hidden;
			background: #ffffff;
			box-shadow: 0 6px 20px rgba(15, 23, 42, 0.05);
			max-height: 48vh;
			overflow-y: auto;
		}

		.bulk_preview_table {
			width: 100%;
			border-collapse: separate;
			border-spacing: 0;

			thead th {
				position: sticky;
				top: 0;
				z-index: 1;
				background: #f8fafc;
				text-align: left;
				font-size: 12px;
				font-weight: 600;
				color: #475569;
				padding: 0.7rem 0.9rem;
				border-bottom: 1px solid #e2e8f0;
			}

			tbody td {
				padding: 0.65rem 0.9rem;
				border-bottom: 1px solid #f1f5f9;
				vertical-align: middle;
				font-size: 13px;
			}

			tbody tr:last-child td {
				border-bottom: none;
			}
		}

		.bulk_preview_index {
			color: #64748b;
			font-weight: 600;
		}

		.bulk_preview_product_name {
			font-weight: 500;
			color: #0f172a;
		}

		.bulk_preview_product_input_wrap {
			display: flex;
			align-items: center;
			gap: 0.45rem;
		}

		.bulk_preview_product_input_main {
			flex: 1;
			min-width: 180px;
		}

		.bulk_preview_unit_text {
			display: inline-flex;
			padding: 0.3rem 0.6rem;
			border-radius: 999px;
			background: #f1f5f9;
			color: #334155;
			font-weight: 600;
			font-size: 12px;
		}

		.bulk_preview_status_new,
		.bulk_preview_status_existing {
			display: inline-flex;
			padding: 0.25rem 0.6rem;
			border-radius: 999px;
			font-size: 11px;
			font-weight: 700;
			text-transform: uppercase;
			letter-spacing: 0.03em;
		}

		.bulk_preview_status_new {
			background: #fff7ed;
			color: #9a3412;
		}

		.bulk_preview_status_existing {
			background: #f0fdf4;
			color: #166534;
		}

		.bulk_preview_actions {
			text-align: right;
		}

		.bulk_preview_delete {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			width: 30px;
			height: 30px;
			border-radius: 8px;
			border: 1px solid #fecaca;
			background: #fff5f5;
			color: #dc2626;
			cursor: pointer;
			transition: all 0.15s ease;

			&:hover:not(:disabled) {
				background: #fee2e2;
			}

			&:disabled {
				opacity: 0.45;
				cursor: not-allowed;
			}
		}

		.product {
			margin-bottom: 0.5em;
			padding: 1em;
			padding-top: 0.5em;
			border: 1px solid $gray-100;
			border-radius: 8px;
			background-color: $gray-50;

			display: flex;
			align-items: flex-end;

			.product_label {
				display: block;
				font-weight: 500;
				font-size: 13px;
				margin-bottom: 3px;
			}

			.button {
				margin: 1px;
				margin-left: 7px;
			}

			.product_content_warning {
				width: 100%;
				display: flex;
				align-items: center;

				> svg {
					margin-right: 10px;
					color: $danger-color;
				}

				> div > div > div {
					border: 1px solid $danger-color;
					&:hover {
						border-color: $danger-color;
					}
				}
			}

			.product_message {
				padding: 0;
				font-size: 13px;
				color: $danger-color;
			}

			.product_content {
				width: 100%;
				display: flex;
			}

			.selector {
				display: flex;
				justify-content: space-between;

				span {
					font-weight: bold;
				}
			}
		}

		.button_add {
			padding-top: 0.5em;
			display: flex;
			justify-content: center;
		}
	}

	.modal_title {
		padding-bottom: 0.5rem;
	}
}
